<template>
    <ul class="timeline">
        <li class="timeline-inverted">
            <div class="timeline-badge">
                <svg class="bi bi-circle-fill text-primary icon" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8"/>
                </svg>
                <!-- <b-icon icon="circle-fill" variant="primary" class="icon"></b-icon> -->
            </div>
            <div class="timeline-year">
                <h3>2006-2009</h3>
            </div>
            <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4 class="timeline-title">The Early Years (2006 - 2009)</h4>
                </div>
                <div class="timeline-body">
                    <p>C-Suite Labs (formerly known as "Onoko") was founded in 2006 by Janakan Arulkumarasan and James Low. The initial years were a disaster - we built a number of social apps, but struggled to gain traction. In fact, our most successful product in this period gained fewer than 1000 users!</p>
                </div>
            </div>
        </li>
        <li>
            <div class="timeline-badge">
                <svg class="bi bi-circle-fill text-primary icon" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8"/>
                </svg>
            </div>
            <div class="timeline-year">
                <h3>2009-2015</h3>
            </div>
            <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4 class="timeline-title">The Social Years (2009 - 2015)</h4>
                </div>
                <div class="timeline-body">
                    <p>The development of the Facebook Platform in 2008 created a wave of opportunity for our nascent team. We built a number of highly-viral social apps, acquiring over 100 million installed users over several years. Our headline success made us a marketing/tech partner of choice for many Fortune 500 brands, including Starbucks, Disney, and Coca Cola.</p>
                </div>
            </div>
        </li>
        <li class="timeline-inverted">
            <div class="timeline-badge">
                <svg class="bi bi-circle-fill text-primary icon" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8"/>
                </svg>
            </div>
            <div class="timeline-year">
                <h3>2016-2018</h3>
            </div>
            <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4 class="timeline-title">The Community Years (2016 - 2018)</h4>
                </div>
                <div class="timeline-body">
                    <p>In 2015, we decided to divest our social assets, and focus on building Oikos, a new social platform for small communities. We enjoyed moderate success, although we suffered a number of setbacks, especially due to unexpected changes in iOS rules. In this time, however, we developed a deep understanding of Cloud technologies, and B2B marketing - skills which have served us well. We continue to maintain Oikos for existing customers.</p>
                </div>
            </div>
        </li>
        <li>
            <div class="timeline-badge">
                <svg class="bi bi-circle-fill text-primary icon" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8"/>
                </svg>
            </div>
            <div class="timeline-year">
                <h3>2019 - now</h3>
            </div>
            <div class="timeline-panel">
                <div class="timeline-heading">
                    <h4 class="timeline-title">The C-Suite Years (2019 - now)</h4>
                </div>
                <div class="timeline-body">
                    <p>In 2018, we tried to launch a liquid market for raw cloud computing power. To validate demand, we built a small community of CTOs in South East Asia. The community rejected our cloud computing product, but loved the idea of connecting with their CTO peers. We decided to make this our focus, and are now focused on building C-Suite Circle - the world's largest network of senior business leaders.</p>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'timeline',
};
</script>
<style lang="scss" scoped>
.timeline {
    list-style: none;
    padding: 20px 0 20px;
    position: relative;
    margin-bottom: 0;
}

.timeline:before {
    top: 0;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 1px;
    left: 50%;
    margin-left: -1.5px;
    border-left: 1px dashed $primary;
    opacity: 0.7;
}

.timeline>li {
    position: relative;
}

.timeline>li:before,
.timeline>li:after {
    content: " ";
    display: table;
}

.timeline>li:after {
    clear: both;
}

.timeline>li:before,
.timeline>li:after {
    content: " ";
    display: table;
}

.timeline>li:after {
    clear: both;
}

.timeline>li>.timeline-year {
    position: absolute;
    top: 68px;
    left: auto;
    right: 0;
    width: 50%;
    text-align: left;

    h3 {
        margin-left: 40px;
        color: #17032F;
        font-size: 30px;
        font-weight: 900;
    }
}

.timeline>li.timeline-inverted>.timeline-year {
    text-align: right;
    right: auto;
    left: 0;
    h3 {
        margin-right: 40px;
    }
}

.timeline>li>.timeline-panel {
    width: 46%;
    float: left;
    padding: 35px;
    position: relative;
    background-color: #ffffff;
    box-shadow: 0px 20px 35px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    &:hover {
        background-color: #e2d8ea;
    }

    h4 {
        color: #000112;
        font-size: 22px;
        line-height: 1.4;
        font-weight: 700;
        margin-bottom: 20px;
    }
}

.timeline>li>.timeline-badge {
    cursor: pointer;
    width: 29px;
    height: 29px;
    line-height: 21px;
    font-size: 1.4em;
    text-align: center;
    position: absolute;
    background-color: rgba(155, 100, 190, 0.29);
    top: 74px;
    left: 50%;
    margin-left: -16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.5s linear;

    .icon {
        font-size: 11px;
    }

    &:hover {
        transform: scale(1.3);
    }
}

.timeline>li.timeline-inverted>.timeline-panel {
    float: right;
}

.timeline-title {
    margin-top: 0;
    color: inherit;
}

.timeline-body>p,
.timeline-body>ul {
    margin-bottom: 0;
    color: #505B64;
    font-size: 15px;
    line-height: 24px;
}

@media (max-width: 767px) {
    ul.timeline:before {
        left: 20px;
    }
    ul.timeline>li>.timeline-panel {
        width: calc(100% - 46px);
        width: -moz-calc(100% - 46px);
        width: -webkit-calc(100% - 46px);
        box-shadow: none;
        background: transparent;
        padding: 0 0 25px;

        &:hover {
            background-color: transparent;
        }
    }
    ul.timeline>li>.timeline-badge {
        left: 5px;
        margin-left: 0;
        top: 25px;
    }
    .timeline > li > .timeline-year,
    .timeline > li.timeline-inverted > .timeline-year {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        width: 87%;
        text-align: left;
        margin-top: 19px;
        margin-bottom: 15px;
        margin-left: 47px;
        overflow: hidden;

        h3 {
            margin-left: 0;
            margin-right: 0;
        }
    }

    ul.timeline>li>.timeline-panel {
        float: right;
    }
    ul.timeline>li>.timeline-panel:before {
        border-left-width: 0;
        border-right-width: 15px;
        left: -15px;
        right: auto;
    }
    ul.timeline>li>.timeline-panel:after {
        border-left-width: 0;
        border-right-width: 14px;
        left: -14px;
        right: auto;
    }
}
</style>
